import { isAnalyticsEnabled } from '@/services/analytics/config';
import { setupAnalytics } from '@/services/analytics/setup';
import { setupAnalyticsUserIdSync } from './user-id';

export default function (): void {
  if (!isAnalyticsEnabled()) return;
  setupAnalytics();
  setupAnalyticsUserIdSync();
}
